import TitlePage from "../../components/layout/Page/TitlePage";
import { useSnackbar } from "notistack";
import HttpService from "../../services/HttpService";
import {
  Select,
  MenuItem,
  Box,
  InputLabel,
  FormControl,
  TextField,
  Button,
} from "@mui/material";
import AccordionCombination from "../../components/AccordionControlled/AccordionCombination";
import { useEffect, useState } from "react";
import AsyncButton from "../../components/AsyncButton/AsyncButton";
import DialogAction from "../../components/Dialog/DialogAction";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";

interface IEmail {
  id: number;
  description: string;
  crm_emails: { html_body: string };
}

const EmailsDashboard = () => {
  document.title = "Διαχείριση Emails";

  const [emails, setEmails] = useState<IEmail[]>([]);
  const [emailCategory, setEmailCategory] = useState<number | undefined>();
  const [htmlBody, setHtmlBody] = useState<string>();
  const [openPreview, setOpenPreview] = useState<boolean>(false);

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { enqueueSnackbar } = useSnackbar();

  const editEmail = async () => {
    setIsLoading(true);
    try {
      await HttpService.getAxiosClient().patch(
        `${process.env.REACT_APP_BACKEND_URL}/crm/manage-emails/${emailCategory}`,
        {
          html_body: htmlBody,
        }
      );
      const email_to_update = emails?.find(
        (email) => email.id == emailCategory
      );
      const email_index = email_to_update && emails.indexOf(email_to_update);
      const updated_emails = emails;

      email_index &&
        email_index !== -1 &&
        ((updated_emails[email_index] = {
          ...email_to_update,
          crm_emails: { html_body: htmlBody || "" },
        }),
        setEmails(updated_emails));

      enqueueSnackbar("Επιτυχής επεξεργασία email", { variant: "success" });
    } catch (error) {
      console.error(error);
      enqueueSnackbar(
        "Παρουσιάστηκε σφάλμα, παρακαλούμε προσπαθήστε αργότερα.",
        { variant: "error" }
      );
    }
    setIsLoading(false);
  };

  const fetchCategories = async () => {
    try {
      const response = await HttpService.getAxiosClient().get(
        `${process.env.REACT_APP_BACKEND_URL}/crm/emails`
      );
      setEmails(
        response.data.sort((a: any, b: any) =>
          a.description.localeCompare(b.description, "el")
        )
      );
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchCategories();

    return () => {
      setEmails([]);
    };
  }, []);

  return (
    <>
      <TitlePage title='Διαχείριση Emails' backButton={false} />
      <AccordionCombination
        accordions={[
          {
            title: (
              <Box display='flex' gap={2}>
                Οδηγίες Χρήσης
                <FormatListBulletedIcon />
              </Box>
            ),
            children: (
              <ul>
                <li style={{ marginBottom: 5 }}>
                  Αν θέλετε να εισάγονται δυναμικά μεταβλητές στο email θα
                  πρέπει να δηλώνονται στα πλαίσια{" "}
                  <span style={{ fontWeight: "bold" }}>
                    ${"{Δυναμική_μεταβλητή}"}
                  </span>
                  ,
                  <br />
                  <span style={{ textDecoration: "underline" }}>πχ:</span>{" "}
                  <span style={{ fontWeight: "bold" }}>
                    ${"{fullName}"}
                  </span>{" "}
                  για την χρήση του ονοματεπώνυμου του χρήστη
                </li>
                <li>
                  Διαθέσιμες δυναμικές μεταβλητές:
                  <ol>
                    <li><span style={{ fontWeight: "bold" }}>fullName:</span> Ονοματεπώνυμο Παραλήπτη</li>
                    <li><span style={{ fontWeight: "bold" }}>application_url:</span> Δυναμικά το Link της αίτησης για προβολή της στο σύστημά 
                      μας μέσω του κουμπιού ανακατεύθυνσης «Προβολή Αιτήματος»</li>
                    <li><span style={{ fontWeight: "bold" }}>request_title:</span> Ο τύπος αιτήματος που πραγματοποιήθηκε.
                      Χρησιμοποιείται για την ενημέρωση των Οργηανικών Μονάδων</li>
                    <li style={{ marginTop: '10px' }}><span style={{ fontStyle: 'italic' }}>Μεταβλητές για Επικοινωνία με Τοποθεσία / Επαγγελματία</span></li>
                    <ul>
                      <li><span style={{ fontWeight: "bold" }}>first_name:</span> Όνομα Επιχείρησης που έχει καταχωρήσει το αίτημα Επικοινωνίας</li>
                      <li><span style={{ fontWeight: "bold" }}>last_name:</span> Επώνυμο Επιχείρησης που έχει καταχωρήσει το αίτημα Επικοινωνίας</li>
                      <li><span style={{ fontWeight: "bold" }}>email:</span> Email Επιχείρησης που έχει καταχωρήσει το αίτημα Επικοινωνίας</li>
                      <li><span style={{ fontWeight: "bold" }}>phone:</span> Τηλέφωνο Επιχείρησης που έχει καταχωρήσει το αίτημα Επικοινωνίας</li>
                      <li><span style={{ fontWeight: "bold" }}>co_name:</span> Επωνυμία Επιχείρησης που έχει καταχωρήσει το αίτημα Επικοινωνίας</li>
                      <li><span style={{ fontWeight: "bold" }}>descr_co:</span> Περιγραφή Συνεργασίας</li>
                    </ul>
                    <li style={{ marginTop: '10px' }}><span style={{ fontStyle: 'italic' }}>Μεταβλητές για κράτηση Τοποθεσίας</span></li>
                    <ul>
                      <li><span style={{ fontWeight: "bold" }}>locationTitle:</span> Ονομασία Τοποθεσίας</li>
                      <li><span style={{ fontWeight: "bold" }}>afm:</span> ΑΦΜ του χρήστη / επιχείρησης που πραγματοποιήσε την κράτηση</li>
                      <li><span style={{ fontWeight: "bold" }}>phone_number:</span> 
                        Αριθμός Τηλεφώνου του χρήστη / επιχείρησης που
                        πραγματοποιήσε την κράτηση</li>
                      <li><span style={{ fontWeight: "bold" }}>email:</span> Email του χρήστη / επιχείρησης που πραγματοποιήσε την κράτηση</li>
                      <li><span style={{ fontWeight: "bold" }}>date_from:</span> Επιθυμητή Ημερομηνία για έναρξη κράτησης</li>
                      <li><span style={{ fontWeight: "bold" }}>date_to:</span> Επιθυμητή Ημερομηνία για λήξη Κράτησης</li>
                      <li><span style={{ fontWeight: "bold" }}>info:</span> 
                        Διευκρινήσεις / Ερωτήσεις του χρήστη που πραγματοποιεί την κράτηση</li>
                      <li><span style={{ fontWeight: "bold" }}>title:</span> Επωνυμία Εταιρείας που πραγματοποιεί την κράτηση</li>
                    </ul>
                  </ol>
                </li>
              </ul>
            ),
            // <Typography>List: 1.2.3.4.</Typography>
          },
        ]}
      />
      <Box mt={4} mb={2}>
        <FormControl fullWidth>
          <InputLabel id='select-email-category'>
            Επιλέξτε E-mail για τροποποίηση
          </InputLabel>
          <Select
            label='Επιλέξτε E-mail για τροποποίηση'
            labelId='select-email-category'
            value={emailCategory}
            onChange={(e) => {
              setEmailCategory(e.target.value as number),
              setHtmlBody(
                emails?.find((email) => email.id == e.target.value)
                  ?.crm_emails?.html_body || ""
              );
            }}
          >
            {emails.map((option: IEmail) => {
              return (
                <MenuItem key={option.id} value={option.id}>
                  {option.description}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </Box>
      {htmlBody
        ? (
          <Box mb={2} mt={4}
            display='flex' justifyContent='end'>
            <Button variant='outlined' onClick={() => setOpenPreview(true)}>
              Προεπισκόπηση e-mail
            </Button>
          </Box>
        )
        : null}
      {emailCategory
        ? (
          <>
            <TextField
              fullWidth
              multiline
              minRows={5}
              value={htmlBody}
              onChange={(e) => setHtmlBody(e.target.value)}
            />
            <Box my={2} display='flex'
              justifyContent='end'>
              <AsyncButton
                disabled={
                  htmlBody ==
                  emails?.find((email) => email.id == emailCategory)?.crm_emails
                    ?.html_body || !htmlBody
                }
                isLoading={isLoading}
                title='Ενημέρωση E-mail'
                onClick={editEmail}
              />
            </Box>
          </>
        )
        : null}
      <DialogAction
        fullWidth
        maxWidth='xl'
        scroll='paper'
        open={openPreview}
        title='Προεπισκόπηση E-mail'
        content={
          <div dangerouslySetInnerHTML={{ __html: htmlBody || "" }}></div>
        }
        mode='info'
        handleClose={() => setOpenPreview(false)}
        onAccept={() => undefined}
      />
    </>
  );
};

export default EmailsDashboard;
